import React from 'react';
import PropTypes from 'prop-types';
import MaskedInput from 'react-maskedinput';
import TextMask from 'react-text-mask';
import { connect } from 'react-redux';
import cx from 'classnames';
import {translate} from "react-i18next";

import { editVehicleClick } from '../../../Modal/SettingsModal/VehiclesSettings/actions';
import Step from './Step';
import FloatingLabelInput from '../../../common/FloatingLabelInput';
import FloatingLabelSelect from '../../../common/FloatingLabelSelect';
import FloatingLabelMaskedInput from '../../../common/FloatingLabelMaskedInput';
import FloatingLabelTextMask from '../../../common/FloatingLabelTextMask';
import { createRange } from '../../../../utils/helpers';
import { autocatalogActions } from '../../../../actions';

@translate(['register'], {wait: true})
class VehicleStep extends Step {
  constructor(props) {
    super(props);
    this.state = {
      color: '',
      issueYear: null,
      make: '',
      model: '',
      number: '',
      vin: '',
      vinError: '',
      noCarGovNumber: true,
      isNew: props.vehicleIsNew
    };
  }

  componentDidMount() {
    const { dispatch } = this.props

    this.props.handleFetchBrands()
  }


  handleBackClick(e) {
    e.preventDefault();
    this.props.decreaseStepIndex()
  }

  handleVin = (e) => {
    const vin = e.target.value.replace(/\s/g, '')
    const { t } = this.props


    this.setState({
      vin: vin,
      vinError: vin.length != 17 ? t('register:vin_error') : ''
    });
  }

  handleNextClick(e) {
    e.preventDefault();
    this.props.increaseStepIndex()
    this.props.handleSaveClick(this.state);
  }

  handleNoCarGovNumber = (e) => {
    const noCarGovNumber = e.target.checked
    this.setState({
      noCarGovNumber: noCarGovNumber,
      number: noCarGovNumber ? '' : this.state.number
    })
  }

  handleNumber = (e) => {
    const { noCarGovNumber } = this.state
    this.setState({
      number: e.target.value,
      noCarGovNumber: e.target.value.length > 0 ? false : true
    });
  }

  handleBrandChange = (e) => {
    e.preventDefault();
    this.setState({make: e.target.value, model: ''})
    this.props.handleFetchModels(e.target.value)

  }
  handleModelChange = (e) => {
    e.preventDefault();
    this.setState({model: e.target.value})
  }

  render() {
    const { t, autocatalog } = this.props;
    const currentYear = new Date().getFullYear()
    const startYear = currentYear - 55
    let years = createRange(startYear, currentYear).map((year) =>
      <option value={year} >{year}</option>
    ).reverse();

    years.unshift(
      <option></option>
    )

    const { vinError, vin } = this.state

    let brands = []
    let models = []
    
    if (autocatalog && autocatalog.brands){
      
      brands = autocatalog.brands.map((brand) =>
        <option value={brand.id} >{brand.name}</option>
      )
      brands.unshift(
        <option></option>
      )
  
    }
    if (autocatalog && autocatalog.models){
      
      models = autocatalog.models.map((models) =>
        <option value={models.id} >{models.name}</option>
      )
      models.unshift(
        <option></option>
      )
  
    }

    return (
      <div className="container">
        <a onClick={this.handleBackClick} className="backStep" href=""></a>
        <form className="popupForm popupRegistrationForm vehicleStep" action="#">
          <div className="stepTitle">
            <h2>{t('register:car')}</h2>
            <div className="note">{t('register:car_note')}</div>
          </div>
          <div className="popupForm__body">
            <div className="row">
              <div className="float-left halfsize padding-right-24"><FloatingLabelSelect type="text" label={t('register:car_make')} onChange={this.handleBrandChange}>{brands}</FloatingLabelSelect></div>
              <div className="float-right halfsize"><FloatingLabelSelect type="text" label={t('register:car_model')} onChange={this.handleModelChange}>{models}</FloatingLabelSelect></div>
            </div>
            <div className="row"><FloatingLabelMaskedInput mask="*****************" placeholderChar=' ' error={vinError} placeholder='' value={vin} type="text" label={t('register:car_vin')} onChange={this.handleVin}/></div>

            <div className="row">
              <div className="float-left halfsize padding-right-24">
                <FloatingLabelSelect type="number" label={t('register:car_issue_date')} onChange={e => {
                  e.preventDefault();
                  this.setState({issueYear: e.target.value});
                }}>
                  {years}
                </FloatingLabelSelect>
              </div>
              <div className="float-right halfsize">
                <FloatingLabelInput type="text" label={t('register:car_color')} onChange={e => {
                  e.preventDefault();
                  this.setState({color: e.target.value});
                }}/>
              </div>
            </div>
            <div className="row">
              <FloatingLabelTextMask guide={false} mask={[/[аА-яЯ]/, /[0-9]/, /[0-9]/, /[0-9]/, /[аА-яЯ]/, /[аА-яЯ]/, /[0-9]/, /[0-9]/, /[0-9]*/]}
                type="text" label={t('register:car_gov_number')} value={this.state.number} onChange={this.handleNumber}/>
              <div className="dont_have_yet">
                <label className="checkbox"><input checked={this.state.noCarGovNumber} type="checkbox" onChange={this.handleNoCarGovNumber} /><span>{t('register:dont_have_yet')}</span></label>
              </div>
            </div>
          </div>
          <div className="rowButton">
            <button
            onClick={this.handleNextClick} className="btn"><span>{t('register:continue')}</span></button>
          </div>
        </form>
      </div>
    );
  }
}

VehicleStep.propTypes = {
  handleSaveClick: PropTypes.func,
  errors: PropTypes.array,
};

export default connect(
  (state) => {
    return {
      errors: state.settings.vehiclesErrors,
      autocatalog: state.autocatalog
    };
  },
  (dispatch) => {
    return {
      handleSaveClick(vehicle) {
        return dispatch(editVehicleClick({
          vehicle: {
            ...vehicle,
          },
        }));
      },
      handleFetchBrands(){
        return dispatch(autocatalogActions.brands())
      },
      handleFetchModels(brand){
        return dispatch(autocatalogActions.models(brand))
      }
    };
  },
)(VehicleStep);



// WEBPACK FOOTER //
// ./src/components/Auth/Registration/Steps/VehicleStep.js